query referenciaGcpjDocumentoSelect {
    data: referenciasGcpjsDocumentos(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}